export default __webpack_public_path__ + "static/font-298732f6ba50541e5d0f1be5a2192daa.ttf";